/**
 * AURORA DS — nałożenie motywu PRZED pierwszym malowaniem.
 *
 * DLACZEGO OSOBNY PLIK, A NIE ThemeProvider. `layout.tsx` w Next App Router jest
 * Server Component. Import z barrela `@insolitum/ui` ciągnie tam całą bibliotekę
 * klienta (hooki z `useState`, konteksty) i build wywala się na
 * „You're importing a component that needs useState…". `ThemeProvider` z kolei
 * ma `'use client'`, bo musi — trzyma stan i konteksty.
 *
 * Sam skrypt inicjalizujący niczego takiego nie potrzebuje: to zwykły `<script>`
 * z treścią, więc może być czystym Server Component. Dlatego siedzi tutaj, bez
 * dyrektywy, i importuje się go PODŚCIEŻKĄ:
 *
 *     import { ThemeScript } from '@insolitum/ui/providers/themeScript';
 *
 * Klucze `localStorage` też są tutaj, bo są jedynym kontacktem między tym
 * skryptem a providerem — trzymanie ich w jednym miejscu jest tym, co gwarantuje,
 * że skrypt czyta dokładnie to, co provider zapisuje.
 */

export const THEME_STORAGE_KEY = 'insolitum-theme';
export const DENSITY_STORAGE_KEY = 'insolitum-density';
export const CONTRAST_STORAGE_KEY = 'insolitum-contrast';

/**
 * Musi być synchroniczny (inaczej strona zdąży się pomalować) i nie może rzucać,
 * gdy `localStorage` jest zablokowany — tryb prywatny, iframe bez zgody na
 * storage. Moduły są osadzane w powłoce w iframie, więc to nie hipoteza.
 *
 * Wstawiaj jako `<ThemeScript />` w `<head>` (Next) albo inline w `index.html`
 * (Vite — nie zaimportuje TS do HTML-a, więc powłoka ma kopię, a zgodności
 * kluczy pilnuje `aurora-design-invariants`).
 */
export const themeInitScript = `(function(){try{
var r=document.documentElement;
var m=localStorage.getItem('${THEME_STORAGE_KEY}')||'dark';
if(m==='system'){m=window.matchMedia('(prefers-color-scheme: light)').matches?'light':'dark';}
if(m!=='light'&&m!=='dark'){m='dark';}
r.setAttribute('data-mode',m);
r.classList.remove('light','dark');r.classList.add(m);
r.style.colorScheme=m;
var d=localStorage.getItem('${DENSITY_STORAGE_KEY}');
if(d==='comfortable'||d==='compact'||d==='kiosk'){r.setAttribute('data-density',d);}
var c=localStorage.getItem('${CONTRAST_STORAGE_KEY}');
if(c==='high'){r.setAttribute('data-contrast','high');}else{r.removeAttribute('data-contrast');}
}catch(e){}})();`;

/** Gotowy tag dla `<head>`. Bez `'use client'` — to zwykły element, nie komponent stanowy. */
export function ThemeScript() {
  return <script dangerouslySetInnerHTML={{ __html: themeInitScript }} />;
}
